import { Licensing } from '@adaptiva/core/licensing';
import { Pipe, PipeTransform } from '@angular/core';
import { IProductTrialDisplay } from '../interfaces';

@Pipe({ name: 'adaAiProductTrialColor' })
export class AiProductTrialColorPipe implements PipeTransform {

	public transform(_product: IProductTrialDisplay): string {
		switch (_product.state) {
			case Licensing.States.ENABLED:
			case Licensing.States.ENABLING:
				return 'ada-color-success';
			case Licensing.States.NOT_PRESENT:
				return 'ada-color-primary';
			default:
				return 'ada-color-foreground';
		}
	}

}
